/**
 * Header slots — wired into `config.header`.
 *
 * No Method or Playbook menu. Two app-owned menus sit alongside the shared
 * chrome: "SafeSystem" advertises the SafeSystem suite (every entry disabled —
 * this app's keys don't include those products) and "Services" holds Abley
 * service links.
 */

import type { HeaderItem } from '#lib/components/Header.svelte';
import type { MenuItem } from '#lib/components/MenuButton.svelte';
import { APPS } from '#lib/apps/index.js';
import { PRODUCT_SUITE_APPS, type AppId } from '#lib/apps/types.js';

const SAFESYSTEM_SUITE = PRODUCT_SUITE_APPS.find((suite) => suite.id === 'safesystem');

/** SafeSystem products in suite order, all disabled — a shop window, not a nav. */
function safeSystemMenu(): HeaderItem {
	const byId = new Map(APPS.map((config) => [config.id, config]));
	const items: MenuItem[] = ((SAFESYSTEM_SUITE?.apps ?? []) as readonly AppId[])
		.map((id) => byId.get(id))
		.filter((config) => config !== undefined)
		.map((config) => ({
			link: { label: config.name, href: config.basePath, disabled: true }
		}));
	return { title: SAFESYSTEM_SUITE?.name ?? 'SafeSystem', items };
}

const services: HeaderItem = {
	title: 'Services',
	items: [
		['Community & Place', 'community-place'],
		['Digital & Spatial Technology', 'digital-spatial'],
		['Road Safety', 'road-safety'],
		['Strategy & Planning', 'strategy-planning'],
		['Transport Design & Engineering', 'transport-engineering'],
		['Land Development', 'land-development']
	].map(([label, slug]) => ({
		link: { label, href: `https://abley.com/${slug}`, type: 'link' as const }
	}))
};

// Built on demand: `APPS` imports this module, so it is uninitialised at module load.
export const menus = (): HeaderItem[] => [safeSystemMenu(), services];
